import axios from 'axios'
import db from '../services/localstorage'
import Vue from 'vue'
import Router from '@/router/index'
import NProgress from 'nprogress'

// var baseURL='http://192.168.34.47:8081/api'
//var baseURL='http://10.1.8.63/api'
var baseURL= 'https://guard.rifeng.com/api'
let instance = axios.create({
  baseURL: baseURL,

  timeout: 400000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const http = {
  //获取根请求路径
  getBaseUrl(){
    return baseURL;
  },
  post(url, params) {
    return new Promise((resolve, reject) => {
      instance
        .post(url, params, {
          params,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },


  postFile(url, params) {
    return new Promise((resolve, reject) => {
      instance
        .post(url, params)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

//代理方式
  postList(method, url, data, callback, flag) {
    var xhr = null
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest()
    } else {
      xhr = new ActiveXObject('Microsoft.XMLHttp')
    }
    url = baseURL + url
    xhr.open(method, url, flag)
    xhr.withCredentials = true
    xhr.setRequestHeader('Accept', '*/*')
    xhr.setRequestHeader('Authorization', 'Bearer ' + db.get('token'))
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send(JSON.stringify(JSON.parse(data)))
    var response = xhr.response
    console.log(response)
    return response
  },

  get(url, params) {
    return new Promise((resolve, reject) => {
      instance
        .get(url, params)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  delete(url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return instance.get(`${url}${_params}`)
  },
  getParams(url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return instance.get(`${url}${_params}`)
  },
  //导出Excel
  export(url, params, fileName) {
    const loading = this.$loading({
      lock: true,
      text: 'data exporting ...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    return instance
      .post(url, params, {
        // transformRequest: [
        //   params => {
        //     let result = ''
        //     Object.keys(params).forEach(key => {
        //       if (
        //         !Object.is(params[key], undefined) &&
        //         !Object.is(params[key], null)
        //       ) {
        //         result +=
        //           encodeURIComponent(key) +
        //           '=' +
        //           encodeURIComponent(params[key]) +
        //           '&'
        //       }
        //     })
        //     return result
        //   }
        // ],
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(r => {
        const content = r.data
        const blob = new Blob([content])
        if (fileName == '' || fileName == undefined || fileName == null) {
          fileName = `${new Date().getTime()}.xlsx`
        } else {
          fileName = fileName + '.xlsx'
        }
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
        loading.close()
      })
      .catch(r => {
        console.error(r)
        loading.close()
      })
  },
  //下载PDF
  downloadPdf(url, params, filename) {
    const loading = this.$loading({
      lock: true,
      text: 'data downling ...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    return instance
      .post(url, params, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(r => {
        const content = r.data
        const blob = new Blob([content], {
          type: `application/pdf;charset-UTF-8` //word文档为msword,pdf文档为pdf
        })
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = filename
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
          loading.close()
        } else {
          navigator.msSaveBlob(blob)
          loading.close()
        }
      })
      .catch(r => {
        console.error(r)
        loading.close()
      })
  }
}

// 拦截请求
instance.interceptors.request.use(config => {
  NProgress.start()
  if (db.get('token')) {
    config.headers.Authorization = 'Bearer ' + db.get('token')
  }
  return config
})

// 拦截响应
instance.interceptors.response.use(
  config => {
    // config.data = config.data;
    // console.log('data',config.data)
    NProgress.done()
    return config
  },
  error => {
    console.log('error', error)
    if (error == 'Error: Network Error') {
      Vue.prototype.$message.error('Error: Network Error')
      return Promise.reject(error)
    } else if (error.response) {
      let errorMessage =
        error.response.data === null
          ? 'System exception，please contact system admin'
          : error.response.data.msg

      switch (error.response.status) {
        case 404:
          Vue.prototype.$message.error('Sorry,Url is not found')
          break
        case 403:
          Vue.prototype.$message.error(errorMessage)
          break
        case 401:
          Vue.prototype.$message.error('Token is invalid,please login')
          db.clear()
          // location.reload()
          Router.replace('/login')
          break
        default:
          Vue.prototype.$message.error(errorMessage)

          break
      }
    }
    return Promise.reject(error)
  }
)

export default http